import ProgressBar from '../../component/progressBar/ProgressBar.component';
import LoaderComponent from '../Loader/LoaderComponent';

export default function LoadingImportScreen(props: { total: number; current: number; errors: number; latency: number }) {
  const getPercent = (total: number, current: number): number => {
    if (total && current) {
      return (current * 100) / total;
    }
    return 0;
  };

  const formatSeconds = (seconds: number) => {
    var date = new Date(1970, 0, 1);
    date.setSeconds(seconds);
    return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
  };

  return props.current ? (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'absolute', zIndex: '99999', width: '100%', height: '100%', background: 'rgb(0 0 0 / 70%)', top: '0', left: '0' }}>
      <LoaderComponent />

      <span style={{ marginTop: '20px', fontSize: '40px', fontWeight: '600', color: '#FFF', lineHeight: '35px' }}>Importando dados</span>
      <span style={{ fontSize: '20px', color: '#FFF', marginBottom: '40px' }}>Por favor aguarde</span>

      <ProgressBar value={getPercent(props.total, props.current)} style={{ display: 'flex', flexDirection: 'column', color: '#fff', marginBottom: '-10px', marginTop: '-3px', width: '80%' }} />

      <span style={{ marginTop: '30px', fontSize: '20px', color: '#FFF' }}>{formatSeconds(props.latency * (props.total - props.current))} até finalizar</span>

      <span style={{ marginTop: '30px', fontSize: '20px', color: '#FFF' }}>
        {props.current} de {props.total} itens importados
      </span>
      {props.errors > 0 && <span style={{ fontSize: '20px', color: '#FFF' }}>{props.errors > 1 ? `${props.errors} itens` : `${props.errors} item`} com erros</span>}
    </div>
  ) : (
    <></>
  );
}
